import classnames from 'classnames';

import { formatDatetime } from 'helpers/timezone';

import useWindowDimensions, {
  isMobileResolution,
} from 'helpers/useWindowDimensions';

import { STATUSES } from 'config/payment_intent';
const PaymentIntentCardNew = ({ paymentIntent }) => {
  const { width } = useWindowDimensions();
  const isMobile = isMobileResolution(width);

  const articleClasses = classnames('grid-cards', {
    pointer: true,
  });

  const statusCalsses = classnames('th-badge mr5', {
    'th-badge-green': paymentIntent.status === 'succeeded',
    'th-badge-grey': [
      'requires_payment_method',
      'requires_capture',
      'requires_confirmation',
      'processing',
    ].includes(paymentIntent.status),
    'th-badge-pink':
      paymentIntent.status === 'requires_action' ||
      paymentIntent.status === 'canceled',
  });
  const DesktopView = (
    <article className={articleClasses}>
      <div className="apps-card-left-new" style={{ gridColumn: 'span 6' }}>
        <div className="mr6">
          <div className="apps-card-meta">
            <div className="apps-card-app-title-new">
              €{paymentIntent.amount}
            </div>
            <div className="flex flex-row" style={{ gap: '4px' }}>
              <div className="flex flex-column">
                {paymentIntent.stripeId && (
                  <p
                    className="apps-card-app-desc-new"
                    style={{ width: 'max-content' }}
                  >
                    Stripe ID:
                  </p>
                )}
                {paymentIntent.lastPaymentError && (
                  <p className="apps-card-app-desc-new">Error:</p>
                )}
              </div>
              <div className="flex flex-column">
                {paymentIntent.stripeId && (
                  <p className="apps-card-app-desc-new">
                    {paymentIntent.stripeId}
                  </p>
                )}
                {paymentIntent.lastPaymentError && (
                  <p className="apps-card-app-desc-new">
                    {paymentIntent.lastPaymentError.message}
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="apps-card-right-new" style={{ gridColumn: 'span 3' }}>
        {paymentIntent.status && (
          <div className="mr5 flex">
            <span className={statusCalsses}>
              {
                STATUSES.find((status) => status.id === paymentIntent.status)
                  .label
              }
            </span>
          </div>
        )}
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 3', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">
            {formatDatetime(paymentIntent.createdAt)}
          </p>
        </div>
      </div>
    </article>
  );

  const MobileView = (
    <article className={articleClasses}>
      <div className="apps-card-left-new" style={{ gridColumn: 'span 10' }}>
        <div className="apps-card-meta ">
          <div className="apps-card-app-title-new">€{paymentIntent.amount}</div>

          <div className="flex flex-column" style={{ gap: '6px' }}>
            <div
              className="flex flex-row"
              style={{ gap: '6px', maxWidth: '50%' }}
            >
              {paymentIntent.stripeId && (
                <p className="apps-card-app-desc-new">Stripe ID:</p>
              )}
              {paymentIntent.stripeId && (
                <p className="apps-card-app-desc-new">
                  {paymentIntent.stripeId}
                </p>
              )}
            </div>
            <div
              className="flex flex-row"
              style={{ gap: '6px', maxWidth: '50%' }}
            >
              {paymentIntent.lastPaymentError && (
                <p
                  className="apps-card-app-desc-new"
                  style={{ display: 'block' }}
                >
                  Error:
                </p>
              )}
              {paymentIntent.lastPaymentError && (
                <p className="apps-card-app-desc-new">
                  {paymentIntent.lastPaymentError.message}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 2', justifySelf: 'end' }}
      >
        <div>
          <p className="apps-card-app-desc-new">Creation date:</p>
          <p className="apps-card-app-desc-new">
            {formatDatetime(paymentIntent.createdAt)}
          </p>
        </div>
      </div>
      <div
        className="apps-card-right-new"
        style={{ gridColumn: 'span 6', gap: '8px' }}
      >
        {paymentIntent.status && (
          <div className="mr5 flex">
            <span className={statusCalsses}>
              {
                STATUSES.find((status) => status.id === paymentIntent.status)
                  .label
              }
            </span>
          </div>
        )}
      </div>
    </article>
  );

  return isMobile ? MobileView : DesktopView;
};

export default PaymentIntentCardNew;
